import { ClipboardList, LayoutDashboard, PenTool, Target, Video } from '@/components/ui/icons';

const META = {
  dashboards: { icon: LayoutDashboard, title: 'Dashboards', text: 'Build reporting dashboards from your tasks, time tracking and goals.' },
  whiteboards: { icon: PenTool, title: 'Whiteboards', text: 'Brainstorm visually and turn ideas into tasks.' },
  forms: { icon: ClipboardList, title: 'Forms', text: 'Collect requests and turn submissions into tasks.' },
  clips: { icon: Video, title: 'Clips', text: 'Record your screen and share async video.' },
  goals: { icon: Target, title: 'Goals', text: 'Track measurable targets that roll up from your tasks.' },
} as const;

export function Placeholder({ kind }: { kind: keyof typeof META }) {
  const m = META[kind];
  const Icon = m.icon;
  return (
    <div className="page-placeholder">
      <div className="page-placeholder-icon">
        <Icon size={26} />
      </div>
      <h2>{m.title}</h2>
      <p style={{ maxWidth: 380, fontSize: 'var(--fs-md)' }}>{m.text}</p>
      <span className="chip">Coming soon</span>
    </div>
  );
}
